export default "__VITE_ASSET__RxUmD4zi__"